<template>
  <div class="calico-top-factor-page">
    <div class="calico-top-factor-container">
      <div class="calico-top-factor-row">
        <CalicoTopFactor
          :score="10"
          title="factor"
        />
      </div>
      <div class="calico-top-factor-row">
        <CalicoTopFactor
          :score="-10"
          title="factor"
        />
      </div>
    </div>
  </div>
</template>
  
  <script lang="js">
  import CalicoTopFactor from '@/components/calico/topFactor/index.vue'
  export default {
    name: 'CalicoTopFactorPage',
    components: {
      CalicoTopFactor
    },
    data () {
      return {
        text1: '',
      }
    },
    watch: {
      text1 (value) {
        console.log(value)
      },
    }
  }
  </script>
  <style lang="scss">
  .calico-top-factor-page {
    display: flex;
    justify-content: center;
    align-items: center;
    .calico-top-factor-container {
      @include stack-space($space-large);
      background: black;
      padding: $space-medium;
      .calico-top-factor-row {
        @include inline-space($space-large);
      }
    }
  }
  </style>
  